<template>
  <div class="bg-secondary-3 p-3 mt-3 rounded">
    <div class="row px-3">
      <div class="col-12 col-md-4">
        <span class="font-weight-normal text-gray font-14">
          Nombre del Documento:
        </span>
        <p class="font-16">{{ document.documentName }}</p>
      </div>
      <div class="col-12 col-md-6">
        <span v-if="fileName" class="font-weight-normal text-gray font-14">
          Archivo:
        </span>
        <p class="font-16">{{ fileName }}</p>
      </div>
      <div class="col-12 col-md-2 text-right">
        <action-button
          v-if="(!readOnly && !addingAddendum) || this.document.file"
          class="mr-2 mt-2"
          i="fas fa-times-circle"
          variant="danger"
          @click="() => $emit('on-remove', index)"
        />
        <action-button
          class="mr-2 mt-2"
          i="fas fa-file-download"
          variant="success"
          @click="() => $emit('on-download', document)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
export default {
  name: 'BidDocumentRow',
  components: {
    ActionButton,
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    document: {
      type: Object,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: () => false,
    },
    addingAddendum: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    fileName() {
      return this.document.file?.name;
    },
  },
};
</script>

<style lang="scss" scoped></style>
